import { createContext, useContext } from "react";

/** Optionaler Weg aus der Meldung, z. B. „Plan ansehen“ bei erreichter Plan-Grenze (402, W9). */
/** Oder eine Handlung an Ort und Stelle (W15: „Immer so“ nach dem Ablegen). */
export type ToastAktion = { text: string; zu: string } | { text: string; tun: () => void };
export type ToastApi = (text: string, aktion?: ToastAktion) => void;
export const Kontext = createContext<ToastApi>(() => {});

/** Kurze Rueckmeldung zeigen („Abgelegt.“). */
export function useToast(): ToastApi {
  return useContext(Kontext);
}

/** W73d (D-314 H1): steht gerade eine Meldung? Eigener Kontext, damit `useToast()` bleibt, wie es ist; Vorgabe false, damit
 *  alles ohne Anbieter (Tests) unveraendert laeuft. */
export const SichtbarKontext = createContext(false);

export function useToastSichtbar(): boolean {
  return useContext(SichtbarKontext);
}
